<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' @child-event='getTextVal' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary">采购验收确认</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";

  import {guid} from '@/utils/tableDelete'
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate,
		getMediaId,
		getApproverDetailInfo,
		GetPendingProcessById
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
	import {
		getDepartmentInfo
	} from '@/api/department'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				applyTemplateData: null,
				flowId:null
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			clickChoose(dataVal, name) {
        console.log(name)
        if (name === "申请人员"){
          window.wx.invoke(
              "selectEnterpriseContact",
              {
                fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
                mode: "single", // 必填，选择模式，single表示单选，multi表示多选
                type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
                selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
                selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
              },
              function (res) {
                if (res.err_msg === "selectEnterpriseContact:ok") {
                  if (typeof res.result == "string") {
                    res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
                  }
                  // 已选的部门列表
                  var user = res.result.userList[0];
                  dataVal.Values = [];
                  dataVal.Values.push([user.id, user.name]);
                  dataVal.Value = user.name;
                }
              }
          );
          return
        }
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values.push([depart.id, depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},

			getTemplate: async function() {
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				await this.getFlowTemplateInfo();
				var that = this;
				var applyDep = "";
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach((item, index) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "维修信息") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "申请部门") {
							applyDep = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "申请部门"
							})[0].Values[0][0];
						}
						// if (item.Property.Title[0].Text == "申请部门") {
						// 	item.Disable = true;
						// 	item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
						// 		return t.Property.Title[0].Text == "申请部门"
						// 	})[0].Value
						// 	item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
						// 		return t.Property.Title[0].Text == "申请部门"
						// 	})[0].Values
						// }
						if (item.Property.Title[0].Text == "行政主任") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "行政主任"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "行政经理"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "小战区区董") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "小战区区董"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大战区区董") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "大战区区董"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经理/副总经理") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "总经理/副总经理"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "经理/总监"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经理") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "总经理"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门经理") {
							// item.Values = that.applyTemplateData.TemplateContent.Controls.filter(t => {
							// 	return t.Property.Title[0].Text == "部门经理"
							// })[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "行政经理") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门总经理/总监") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "非营业逐级审批") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "超出申请金额") {
							item.Disable = true;
							item.IsShow = false;
							item.Value = "0";
						}
						if (item.Property.Title[0].Text == "申请金额") {
							item.Disable = true;
							item.Value = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "合计"
							})[0].Value
						}
						// if (item.Property.Title[0].Text == "申请人员") {
						// 	item.Disable = true;
						// 	if (that.applyTemplateData != null) {
						// 		var emp = that.applyTemplateData.TemplateContent.Controls.filter(t => {
						// 			return t.Property.Title[0].Text == "申请人员"
						// 		})[0];
						// 		item.Values = emp.Values;
						// 		item.Value = emp.Value;
						// 	}
						// }
						if (item.Property.Title[0].Text == "申请人员工号") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "核价人员") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "核价人工号") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请原因") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "类别") {
							item.Disable = true;

						}
						if (item.Property.Title[0].Text == "维修") {
							item.Disable = true;
							var controls = that.applyTemplateData.TemplateContent.Controls;
							var controlInfo = controls.filter(data => data.Property.Title[0].Text == "类别")[0];
							if (controlInfo.Value == "option-1600687326862") {
								item.IsShow = true;
							} else {
								item.IsShow = false;
							}
						}
						if (item.Property.Title[0].Text == "总金额合计") {
							item.Disable = true;
							item.Value = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "合计"
							})[0].Value
						}
						if (item.Property.Title[0].Text == "确认核价") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "核价确认（元）") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "核价说明") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "上传附件") {
							item.Disable = true;
						}

						if (item.Property.Title[0].Text == "验收人员") {
							item.Disable = true;
							item.Value = that.logInfo.EmpName
						}
						if (item.Property.Title[0].Text == "申请项目内容") {
							item.Disable = true;
							item.addIsShow = false;
						}
						if (item.Property.Title[0].Text == "申请部门") {
							item.Disable = true;
						}
						if(item.Property.Title[0].Text=="实付金额"){
							item.IsShow = false;
							item.Disable = true;
						}
					});
					var controlsLength = controls.TemplateContent.Controls.length;
					for (var j = 0; j < controlsLength; j++) {
						var controlsData = controls.TemplateContent.Controls[j];
						var departs = title.split("/");
						if (that.applyTemplateData != null) {
							var data = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == controlsData.Property.Title[0].Text
							});
							if (controlsData.Property.Title[0].Text == "申请项目内容") {
								controlsData.addIsShow = false;
								var i = 1;
								// that.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
								// 	if (applyData.Property.Title[0].Text.indexOf("申请项目内容") > -1) {
								// 		if (applyData.Property.Title[0].Text != "申请项目内容") {
								// 			var AddTable = JSON.stringify(controlsData);
								// 			AddTable = JSON.parse(AddTable);
								// 			AddTable.Property.Id = "Table-1600687377709";
								// 			AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
								// 			AddTable.addIsShow = false;
								// 			AddTable.Config.Table.Children.forEach(forDisable => {
								// 				forDisable.Disable = true;
								// 			});
								// 			controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
								// 			i++;
								// 		}
								// 	}
								// });
								controlsData.Config.Table.Children.forEach(childItem => {
									childItem.Disable = true;
								})
							}

							if (controlsData.Property.Title[0].Text == "供应商信息") {
								controlsData.addIsShow = false;
								var i = 1;
								// that.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
								// 	if (applyData.Property.Title[0].Text.indexOf("供应商信息") > -1) {
								// 		if (applyData.Property.Title[0].Text != "供应商信息") {
								// 			var AddTable = JSON.stringify(controlsData);
								// 			AddTable = JSON.parse(AddTable);
								// 			AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
								// 			AddTable.addIsShow = false;
								// 			AddTable.Config.Table.Children.forEach(forDisable => {
								// 				forDisable.Disable = true;
								// 			});
								// 			controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
								// 			i++;
								// 		}
								// 	}
								// });
								controlsData.Config.Table.Children.forEach(childItem => {
									childItem.Disable = true;
								})
							}
						}
					}
					that.templateData = that.assignControl(controls, that.logInfo);
					that.templateData = await that.assignControlBySpNo(controls, that.spNo, that.flowId);
					that.listLoading = false;
					var isXinXi = false;
					var select = that.applyTemplateData.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text == "请选择审批流程"
					})[0].Value;
					
					if (select != "option-1600689940131") {
						isXinXi = true;
					}
					await controls.TemplateContent.Controls.forEach((item) => {
						if(item.Property.Title[0].Text == "财务报销提示"){
							item.Value = "此表单为工程费用验收表，为财务报销凭证2/2";
						}
						if (item.Property.Title[0].Text == "申请人员部门") {
							console.log(item)
							if (item.Value == "option-1601017196593") {
								if (isXinXi) {
									item.Value = "option-1606888822188";
								}
							}
							item.Disable = true;
							item.IsShow = false;
						}
						// if (item.Property.Title[0].Text == "核价上传附件") {
						// 	this.$set(item,'fileNames',[])
						// 	if(item.Values != null){
						// 		item.Values.forEach(data => {
						// 			getMediaId(data[0]).then(res => {
						// 				data[0] = res.MediaId;
						// 				item.fileNames.push({
						// 					"key": res.fileName,
						// 					"val": res.MediaId
						// 				});
						// 			});
						// 		});
						// 		console.log(item)
						// 	}
						// }
						// if (item.Property.Title[0].Text == "申请上传附件") {
						// 	this.$set(item,'fileNames',[])
						// 	if(item.Values != null){
						// 		item.Values.forEach(data => {
						// 			getMediaId(data[0]).then(res => {
						// 				data[0] = res.MediaId;
						// 				item.fileNames.push({
						// 					"key": res.fileName,
						// 					"val": res.MediaId
						// 				});
						// 			});
						// 		});
						// 		console.log(item)
						// 	}
						// }
					});
				});

			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getFlowTemplateInfo: async function() {
				if (this.spNo == null || this.spNo == undefined || this.spNo.length <= 0) {
					return;
				}
				await getApproverDetailInfo(this.spNo).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTextVal(val, name) {
				if (name == "实付金额") {
					var controls = this.templateData.TemplateContent.Controls;
					var applyMoney = parseFloat(controls.filter(item => item.Property.Title[0].Text == "申请金额")[0].Value).toFixed(2);
					var sureMoney = parseFloat(val).toFixed(2);
					var money = sureMoney - applyMoney;
					if (money <= 0) {
						money = 0.00;
					}
					controls.filter(item => item.Property.Title[0].Text == "超出申请金额")[0].Value = money;
				}
			},
			getSelectorVal(val, name) {
				if (name == "实际采购内容与申请内容一致") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "不一致" && val.indexOf(item.Key) > -1;
						})[0];

					var control = controls.filter(item => item.Property.Title[0].Text == "维修信息")[0];

					let contactContents = controls.filter(e => e.Property.Title[0].Text.indexOf("申请项目内容") != -1);
					let index = 0
					// this.$set(control, 'addIsShow', true);
					if (option != null) {
            console.log("不一致?")
            // 补充
            for (let contactContent of contactContents) {
              let contactbf = JSON.parse(JSON.stringify(control));
              let tempObject = {
                type: "",
                project: "",
                num: "",
                unit: ""
              }
              for (let child of contactContent.Config.Table.Children) {
                if (child.Property.Title[0].Text === "维修类别"){
                  let value = ""
                  for (let option1 of child.Config.Selector.Options) {
                    if (option1.Key === child.Value){
                      value = option1.Value[0].Text
                    }
                  }
                  tempObject.type = value
                }
                if (child.Property.Title[0].Text === "维修项目"){
                  tempObject.project = child.Value
                }
                if (child.Property.Title[0].Text === "数量"){
                  tempObject.num = child.Value
                }
                if (child.Property.Title[0].Text === "单位") {
                  tempObject.unit = child.Value
                }
              }

              let children = contactbf.Config.Table.Children
              for (let i = 0; i < children.length; i++) {
                if (children[i].Property.Title[0].Text === "维修类别") {
                  children[i].Value = tempObject.type
                }
                if (children[i].Property.Title[0].Text === "维修项目") {
                  children[i].Value = tempObject.project
                }
                if (children[i].Property.Title[0].Text === "验收数量") {
                  children[i].Value = tempObject.num
                }
                if (children[i].Property.Title[0].Text === "单位") {
                  children[i].Value = tempObject.unit
                }
              }
              let S4 = () => {
                return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
              }
              // contactbf.Property.Id="Table-"+S4();
              // let suc = e => {
              //   return "维修信息" + e
              // }
              // let msg = suc(index)
              contactbf.Property.Title[0].Text = "维修信息" + index

              // if (msg === "维修信息0"){
              //   contactbf.Property.Title[0].Text = "维修信息"
              // }
              index++
              contactbf.IsShow = true
              let temp = controls.filter(e => e.Property.Title[0].Text === "维修信息")[0];
              let number = controls.indexOf(temp);
              console.log(contactbf)
              controls.splice(number,0,contactbf)
            }
            console.log(controls)
						// control.IsShow = true;
					} else {
            control.IsShow = false;
					}
					
					
					// if (option != null) {
					// 	control.IsShow = true;
					// 	control.Config.Table.Children.forEach(item => {
					// 		if (item.Property.Title[0].Text != "备注") {
					// 			item.Property.Require = 1;
					// 		}
					// 		if(item.Property.Title[0].Text == "实付金额"){
					// 			item.IsShow = control.IsShow;
					// 			item.Value = control.IsShow?'':'0';
					// 		}
					// 	})
					// } else {
					// 	control.Config.Table.Children.forEach(item => {
					// 		item.Property.Require = 0;
					// 	})
					// 	control.IsShow = false;
					// }
					controls.forEach(item => {
						if(item.Property.Title[0].Text == "实付金额"){
							item.IsShow = control.IsShow;
							item.Value = control.IsShow?'':'0';
						}
						if(item.Property.Title[0].Text == "备注"){
							item.IsShow = control.IsShow;
							item.Value = control.IsShow?'':'0';
						}
					})
					this.isUpdata = control.IsShow;
				}
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				var IsDelete = false;
				for(var index = this.templateData.TemplateContent.Controls.length-1;index>-1;index--){
					IsDelete = false;
					var item = this.templateData.TemplateContent.Controls[index];
					if (item.Property.Title[0].Text.indexOf("维修信息") > -1) {
						item.Config.Table.Children.forEach(data => {
							if (data.Value == null || data.Value == "") {
								IsDelete = true;
							} else {
								IsDelete = false;
								return;
							}
						})
					}
					if (IsDelete) {
						this.templateData.TemplateContent.Controls.splice(index, 1);
					}
					if(item.Property.Title[0].Text == "关联申请单"){
						item.Value = this.spNo;
					}
				}
				// this.templateData.TemplateContent.Controls.forEach((item, index) => {
					
				// 	if (item.Property.Title[0].Text.indexOf("维修信息") > -1) {
				// 		item.Config.Table.Children.forEach(data => {
				// 			if (data.Value == null || data.Value == "") {
				// 				IsDelete = true;
				// 			} else {
				// 				IsDelete = false;
				// 				return;
				// 			}
				// 		})
				// 	}
				// 	if (IsDelete) {
				// 		this.templateData.TemplateContent.Controls.splice(index, 1);
				// 	}
				// 	if(item.Property.Title[0].Text == "关联申请单"){
				// 		item.Value = this.spNo;
				// 	}
				// })
				
				if(IsDelete){
					for(var i = this.templateData.TemplateContent.Controls.length-1;i>-1;i--){
						var control = this.templateData.TemplateContent.Controls[i];
						if(control.Property.Title[0].Text.indexOf("实付金额")>-1){
							this.templateData.TemplateContent.Controls.splice(i,1);
						}
					}
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control0=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员"})[0]
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0]
				info.SummaryInfo.push({"Text":"申请人信息："+control0.Value + " "+control1.Value  ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control5=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请表别称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请表别称："+control5.Value  ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "核价确认（元）"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"核价确认（元）："+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;
				var toUser = this.templateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "申请人员"
							})[0].Values[0][0];
				//提交
				submitProcess(this.templateId, toUser, this.spNo, this.templateData, this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
